export const PUSH_PREFERENCE_KEYS = [
  "alertOrder",
  "alertReview",
  "alertPromotion",
  "alertExpirationPoints",
] as const;

export interface PushPreferenceResult {
  enabled: boolean;
  device?: {
    fcmToken: string;
    platform: string;
    timestamp: string;
  };
}

export function isSamePushCustomer(token: string, currentToken: string): boolean {
  if (!token || !currentToken) {
    return false;
  }
  if (token === currentToken) {
    return true;
  }

  const identity = pushCustomerIdentity(token);
  return identity !== null && identity === pushCustomerIdentity(currentToken);
}

function pushCustomerIdentity(token: string): string | null {
  try {
    const segment = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const bytes = Uint8Array.from(atob(segment), (character) => character.charCodeAt(0));
    const claims = JSON.parse(new TextDecoder().decode(bytes));
    if (
      typeof claims.group !== "string" || !claims.group ||
      typeof claims.customer_id !== "string" || !claims.customer_id
    ) {
      return null;
    }
    // This is a race guard, not JWT verification; the API still authorizes writes.
    return JSON.stringify([claims.group, claims.customer_id]);
  } catch {
    return null;
  }
}

export function supportsAndroidPushPreferences(version: string): boolean | null {
  if (!version || !/^\d+\.\d+\.\d+$/.test(version)) {
    return null;
  }

  const parts = version.split(".").map(Number);
  const minimum = [8, 2, 73];
  for (let index = 0; index < minimum.length; index++) {
    if (parts[index] !== minimum[index]) {
      return parts[index] > minimum[index];
    }
  }
  return true;
}

export function disableUnavailablePushPreferences(
  customer: any,
  permission: boolean | null
): boolean {
  if (!customer || customer.only_visitor || permission !== false) {
    return false;
  }

  let changed = false;
  for (const key of PUSH_PREFERENCE_KEYS) {
    if (customer[key] && customer[key].push === true) {
      customer[key].push = false;
      changed = true;
    }
  }
  return changed;
}
